export default __webpack_public_path__ + "static/media/horror-dracula.fb134d94.png";